import React from 'react';
import $ from 'jquery';

const Preview = props => {
    const { permalink, previewURL } = props.workData;

    $(document).ready(() => {
        $(`a[href$='#preview-${permalink}']`).click(() => $(`#preview-${permalink} .previewContent`).prepend(`<iframe src=${previewURL}></iframe>`));

        $(`#preview-${permalink} .previewClose`).click(() => $(`#preview-${permalink}.previewContent iframe`).remove());
    });

    return (
        <div className="preview" id={"preview-" + permalink}>
            <input type="radio" name="previewSizes" id="previewMobileSize" className="previewMobileSize" />
            <label htmlFor="previewMobileSize" className="previewSizesLabel previewSizesLabelMobile">
                <svg className="labelSVG" version="1.1" width="58px" height="98px" viewBox="0 0 58 98" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <path d="M48,0H10C4.5,0,0,4.5,0,10v78c0,5.5,4.5,10,10,10h38c5.5,0,10-4.5,10-10V10C58,4.5,53.5,0,48,0z M29,94   c-3.865,0-7-2.238-7-5c0-2.762,3.135-5,7-5c3.864,0,7,2.238,7,5C36,91.763,32.864,94,29,94z M50,79H8V13h42V79z" />
                </svg>
            </label>

            <input type="radio" name="previewSizes" id="previewTabletSize" className="previewTabletSize" />
            <label htmlFor="previewTabletSize" className="previewSizesLabel previewSizesLabelTablet">
                <svg className="labelSVG" version="1.1" width="128px" height="128px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <path d="M37 0h-28c-2.76 0-5 2.24-5 5v38c0 2.76 2.24 5 5 5h28c2.76 0 5-2.24 5-5v-38c0-2.76-2.24-5-5-5zm-14 46c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm15-8h-30v-32h30v32z" />
                </svg>
            </label>

            <input type="radio" name="previewSizes" id="previewDesktopSize" className="previewDesktopSize" defaultChecked />
            <label htmlFor="previewDesktopSize" className="previewSizesLabel previewSizesLabelDesktop">
                <svg className="labelSVG" version="1.1" width="128px" height="128px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <path d="M960 64c-64 0-896 0-896 0C0 64 0 128 0 128v576c0 0 0 64 64 64h320c0 0-192 64-192 128s64 64 64 64h512c0 0 64 0 64-64S640 768 640 768h320c64 0 64-64 64-64V128C1024 128 1024 64 960 64zM960 704H64V128h896V704zM896 192H704c-384 64-576 384-576 384v64h768V192z" />
                </svg>
            </label>

            <a href={"#popup-" + permalink} className="previewClose">&times;</a>

            <div className="previewContent"></div>
        </div > // Preview
    );
};

export default Preview;